import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import KanbanAPI from 'dashboard/api/kanban';

const DEFAULT_OPTIONS = {
  source: [
    'Meta Ads',
    'Google Ads',
    'Prospecção',
    'Indicação',
    'Instagram',
    'Linkedin',
    'Site',
    'Google',
    'Loja',
  ],
  product: [
    'Meta Ads',
    'Google Ads',
    'SDR IA',
    'Site',
    'CRM',
    'Automações',
    'Social Media',
    'Criativos',
  ],
  loss_reason: [],
  cancel_reason: [],
  city: [],
};

export function toSlug(label) {
  return label
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

function defaultsAsOptions(fieldKey) {
  return (DEFAULT_OPTIONS[fieldKey] ?? []).map(label => ({
    key: toSlug(label),
    label,
  }));
}

export function useNativeFieldOptions() {
  const { currentAccount, updateAccount } = useAccount();

  const rawOptions = computed(
    () => currentAccount.value?.settings?.kanban_native_field_options ?? {}
  );

  function getOptions(fieldKey) {
    const saved = rawOptions.value[fieldKey];
    return saved && saved.length ? saved : defaultsAsOptions(fieldKey);
  }

  function getLabels(fieldKey) {
    return getOptions(fieldKey).map(o => o.label);
  }

  async function saveOptions(fieldKey, options) {
    const updated = { ...rawOptions.value, [fieldKey]: options };
    await updateAccount(
      { kanban_native_field_options: updated },
      { silent: true }
    );
  }

  async function renameOptionValue(fieldKey, oldLabel, newLabel) {
    await KanbanAPI.renameOptionValue(fieldKey, oldLabel, newLabel);
  }

  return { getOptions, getLabels, saveOptions, renameOptionValue };
}
